import { ChangeDetectorRef, Component, OnInit, EventEmitter } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { WebapiService } from '../shared/services/webapi.service';
import { ToastrService } from 'ngx-toastr';
import { SlimScrollOptions, SlimScrollEvent } from 'ngx-slimscroll';
import { Store, select } from '@ngrx/store';
import { AppState } from '../store/app.states';
import { getUserInfo } from '../store/selector/selector';
declare var bootstrap;
import { take } from 'rxjs/operators';
declare var $: any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  reinit=1;
  user:any;
  formSubmitting=false;
  removingConnection=false;
  selectedPlaylist=0;
  keyword=''
  inviteForm: FormGroup = this.fb.group({
    email: ['', Validators.compose([Validators.required, Validators.email])]
  });
  playlistsAll: any = [];
  items=[];
  playlists: any = [];
  currentIndex = 8;
  playlistSubmitting=false;
  playlist: FormGroup = this.fb.group({
    title: ['', Validators.compose([Validators.required])],
  });
  editPlaylist="";
  
  opts: SlimScrollOptions;
  scrollEvents: EventEmitter<SlimScrollEvent>;
  
  

  constructor(private fb: FormBuilder,private store: Store<AppState>,public cdr: ChangeDetectorRef,public webApi: WebapiService, public router: Router, private toastrService: ToastrService) {
  }


  ngOnInit()  
  {   
    console.log('init')
    this.getUserData()
    this.getPlaylists() 
    this.scrollEvents = new EventEmitter<SlimScrollEvent>();
    this.opts = new SlimScrollOptions({
      position: "right", // left | right
			barBackground: "rgb(108, 105, 105)", // #C9C9C9
			barOpacity: "0.3", // 0.8
			barWidth: "6", // 10
			barBorderRadius: "10", // 20
			barMargin: "0", // 0
			gridBackground: "#d9d9d9", // #D9D9D9
			gridOpacity: "1", // 1
			gridWidth: "0", // 2
			gridBorderRadius: "20", // 20
			gridMargin: "0", // 0
			alwaysVisible: true, // true
			// visibleTimeout: 1000, // 1000
			alwaysPreventDefaultScroll: undefined, // true
    });

  } 

  updateCount(data){
    let filterList = this.playlistsAll.filter((item)=> { 
      return (item.id==data.playlist) 
    })

    if(filterList.length>0){
      if(data.type=='add'){
        filterList[0].videos_count+=1 
      }else{
        filterList[0].videos_count-=1 
      }
    }
  }

  onFileSelected(event) {

    const file:File = event.target.files[0];

    if (file) {

        this.webApi.setLoader(true)
        const reader = new FileReader();

        const formData = new FormData();
        formData.append("thumbnail", file,file.name);

        this.webApi.uploadProfileImage(formData).subscribe((data: any) => {
          if(data.success){
            this.toastrService.success(data.message);
            reader.addEventListener('load', (event: any) => {
              $('.user-img').attr('src',event.target.result)
            })
            reader.readAsDataURL(file);
          }else{
            this.toastrService.error(data.message);
          }
          this.webApi.setLoader(false)
        },
        error => {
          this.webApi.setLoader(false)
          this.toastrService.error("unable to handle response");
        });
    }
}

  getUserData(){
    this.webApi.setLoader(true)

    this.store.pipe(select(getUserInfo),take(1)).subscribe(data=>{
      this.user = data
      this.webApi.setLoader(false)
    },error=>{
      this.webApi.setLoader(false)
      this.toastrService.error("unable to handle response");
    })

    // this.webApi.getUserData().subscribe((data: any) => {
    //   if(data.success){
    //     this.user=data.data
    //   }else{
    //     this.toastrService.error(data.message);
    //   }
    //   this.webApi.setLoader(false)
    // },
    // error => {
    //   this.toastrService.error("unable to handle response");
    // });
  }

  updateOnlyOnBlur() {
    //this.getPlaylists()
    this.currentIndex = 8;
    let filterList = this.playlistsAll.filter((item)=> { 
      return (item.list_title.toLowerCase().indexOf(this.keyword) >= 0) 
    })
    this.items = filterList.slice(0, this.currentIndex);
  
    this.playlists = filterList;
  }

  LoadMoreLocal(){
    this.currentIndex += 8;
    if(this.keyword.length>0){
      if(this.playlists.length-1<this.currentIndex){
        this.currentIndex = this.playlists.length
      }
    }else{
      if(this.playlistsAll.length-1<this.currentIndex){
        this.currentIndex = this.playlistsAll.length
      }
    }
    
    this.items = this.playlists.slice(0, this.currentIndex);
    this.cdr.detectChanges();
  }

  onSubmitPlaylist(form: FormGroup) {
    if (form.valid && !this.playlistSubmitting) {
      this.playlistSubmitting=true;
      form.value.edit_id=this.editPlaylist;
      this.webApi.createPlaylist(form.value).subscribe((data: any) => {
        if (data.success) {
          form.reset();
          this.getPlaylists();
					this.toastrService.success(data.message);
          $('#create-playlist').modal('hide');
          //this.webApi.setSession(data);
          //this.router.navigateByUrl('/');
        } else {
					this.toastrService.error(data.message);
        }
        this.playlistSubmitting=false;
      },
      error => {
        this.toastrService.error("unable to handle response");
        this.playlistSubmitting=false;
      });
    } else {
      this.webApi.validateAllFields(form);
    }
  }

  getPlaylists(){
    console.log('here')
    this.webApi.setLoader(true)
    let params= {
      //"keyword":this.keyword    
      "keyword":""
    }
    this.webApi.getPlaylists(params).subscribe((data: any) => {
      if(data.success){
        this.playlistsAll=data.data
        this.playlists=data.data
        this.items = this.playlistsAll.slice(0, this.currentIndex);
        this.updateOnlyOnBlur()
      }else{
        this.toastrService.error(data.message);
      }
      this.webApi.setLoader(false)
    },
    error => {
      this.toastrService.error("unable to handle response");
    });
  }

  createPlaylist(list=null){
    this.playlist.patchValue({
      title: ""
    });
    this.editPlaylist="";
    if(list){
      this.editPlaylist=list.id;
      this.playlist.patchValue({
        title: list.list_title
      });
    }
    
    $('#create-playlist').modal('show');
  }

  addVideos(playlistid){
    this.selectedPlaylist=playlistid
    $('#add-videos').modal('show');
  }

  deletePlaylist(playlistid){
    this.webApi.setLoader(true)
    let params= {
      "playlist_id":playlistid    
    }
    this.webApi.deletePlaylist(params).subscribe((data: any) => {
      if(data.success){
        this.playlistsAll = this.playlists.filter((item)=>{ return item.id!=playlistid})
        this.playlists = this.playlists.filter((item)=>{ return item.id!=playlistid})
        this.items = this.playlistsAll.slice(0, this.currentIndex);
        this.toastrService.success(data.message);
      }else{
        this.toastrService.error(data.message);
      }
      this.webApi.setLoader(false)
    },
    error => {
      this.toastrService.error("unable to handle response");
    });
  }

  sharePlaylist(playlistid){
    this.selectedPlaylist=playlistid
    $('#shareToConnections').modal('show');
  }

  // viewPlaylist(playlistid){
  //   this.reinit++;
  //   this.selectedPlaylist=playlistid
  //   $('#playlist-videos').modal('show');
  // }

  viewPlaylist(playlistid,name){
    this.router.navigate(['/playlist/'+this.webApi.slugify(name)+'-'+playlistid]);
  }
  

  get f2(): { [key: string]: AbstractControl } {
    return this.playlist.controls;
  }


}